<div class="image-click-to-enlarge" data-testid="enlarge-image-modal">
  <div class="body-bg-modal"></div>

  <header class="header">
    <div class="header-text-container">
      <h1 class="header-title">{{ modalTitle() }}</h1>
    </div>
    <div class="header-buttons-container">
      <mbp-button data-testid="zoom-in-btn" type="secondary" [text]="'doors.enlargeImageModal.zoomIn' | translate"
        (buttonClick)="onZoomIn()"></mbp-button>
      <mbp-button data-testid="zoom-out-btn" type="secondary" [text]="'doors.enlargeImageModal.zoomOut' | translate"
        (buttonClick)="onZoomOut()"></mbp-button>
      <mbp-button data-testid="download-image-btn" type="primary"
        [text]="'doors.enlargeImageModal.download' | translate" (buttonClick)="onDownload()"></mbp-button>
    </div>
    <button data-testid="close-enlarge-image-btn" type="button" class="close-icon" (click)="close.emit()">
      <img src="assets/icons/close-dark.svg" alt="" />
    </button>
  </header>

  <div class="image-container mbp-scrollbar">
    <img class="enlarged-image" [src]="imageSrc()" [style.transform]="'scale(' + zoomLevel() + ')'" alt="" />
  </div>
</div>
